module.exports = __webpack_public_path__ + "static/img/the-jungle-book.6078fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/the-jungle-book.jpg
// module id = gaGc
// module chunks = 0